/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from './../lib/lib'

export default class ToggleContent {
  constructor() {
    jQuery('body').on('click', '.toggleLnk', (e) => {
      e.preventDefault()

      const targetElement = jQuery(e.currentTarget)
      targetElement.blur()

      const target = this._targetCont(targetElement)

      if (target.length) {
        target.slideToggle()
        targetElement.toggleClass('opened')
      }

      // hide something when opened
      const toggleEl = lib.getDataAttr(targetElement, 'toggle', false)
      if (toggleEl) {
        jQuery(toggleEl).toggle()
      }
    })

    jQuery('body').on('click', '.hiddenCont .closeLnk', () => {
      const targeted = jQuery(this).parents('.hiddenCont')
      jQuery('.toggleLnk').each(() => {
        const lnk = jQuery(this)
        const target = this._targetCont(lnk)

        if (target.get(0) === targeted.get(0)) {
          target.slideToggle()

          lnk.toggleClass('opened')
        }
      })
    })
  }

  _targetCont(lnk) {
    let target
    if (lnk.hasClass('byId')) {
      console.log('lnk.attr(href))', lnk.attr('href'))
      target = jQuery(lnk.attr('href'))
    } else if (lnk.hasClass('byParent')) {
      const par = lib.getDataAttr(lnk, 'parent', '')
      target = lnk.parents(par).find('.hiddenCont')
    } else {
      target = lnk.parent().find('.hiddenCont')
    }
    return target
  }
}
